import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useInView } from 'react-intersection-observer'
import { createUseStyles } from 'react-jss'
import ImageZoom from '@/components/ImageZoom'
import DelayLink from '@/components/DelayLink'
import SimpleSplitText from '@/components/SimpleSplitText'
import BtnLink from '@/components/BtnLink'
import style from './style'

const useStyles = createUseStyles(style)

const ListElement = ({
  item,
  themeBtn,
}) => {
  const classes = useStyles()
  const $title = useRef()
  const $role = useRef()
  const $categories = useRef()
  const $collection = useRef()
  const $additionalData = useRef()
  const [inViewRef, inView] = useInView({ triggerOnce: true })

  const mediaQueryKey = useSelector((state) => state.mediaQuery.key)

  useEffect(() => {
    if (inView) {
      if ($title.current) $title.current.appear()
      if ($additionalData.current) $additionalData.current.appear()
      if ($role.current) $role.current.appear()
      if ($categories.current) $categories.current.appear()
      if ($collection.current) $collection.current.appear()
    }
  }, [inView])

  return (
    <div className={`${classes.root} ListElement__root`}>
      {item.collection && mediaQueryKey <= 1 && (
        <DelayLink
          className={classes.collection}
          to={item.link}
        >
          <SimpleSplitText
            ref={$collection}
            text={item.collection}
            appear
            disableHover
            delay={0.2}
          />
        </DelayLink>
      )}
      <DelayLink
        className={`${classes.image} ListElement__image`}
        to={item.link}
      >
        <ImageZoom
          img={item.image}
          width={420}
          height={325}
          scaleImgOnScroll={true}
          fadeIn
        />
      </DelayLink>
      <div
        ref={inViewRef}
        className={classNames({
          [classes.info]: true,
          ListElement__info: true,
          [classes.spaceBetween]: item.collection,
          [classes.flexEnd]: !item.collection,
        })}
      >
        {item.collection && mediaQueryKey > 1 && (
          <DelayLink
            className={classes.collection}
            to={item.link}
          >
            <SimpleSplitText
              ref={$collection}
              text={item.collection}
              appear
              disableHover
              delay={0.2}
            />
          </DelayLink>
        )}
        {item.role && (
          <div className={classes.role}>
            <SimpleSplitText
              ref={$role}
              text={item.role}
              appear
              disableHover
              delay={0.2}
            />
          </div>
        )}
        {item.categories && (
          <div className={classes.role}>
            <SimpleSplitText
              ref={$categories}
              text={item.categories}
              appear
              disableHover
              delay={0.2}
            />
          </div>
        )}
        <DelayLink
          className={classes.title}
          to={item.link}
        >
          {item.title && (
            <SimpleSplitText
              ref={$title}
              text={item.title}
              appear
              disableHover
              delay={0.2}
            />
          )}
          {item.year && mediaQueryKey > 2 && (
            <div className={classes.additionalData}>
              <SimpleSplitText
                ref={$additionalData}
                text={item.year}
                disableHover
                appear
                delay={0.2}
              />
            </div>
          )}
        </DelayLink>
      </div>
      <div className={`${classes.cta} ListElement__cta`}>
        <BtnLink
          link={item.link}
          theme={themeBtn}
        />
      </div>
      <div className={`${classes.border} ListElement__border`} />
    </div>
  )
}

ListElement.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    additionalData: PropTypes.string,
  }).isRequired,
  themeBtn: PropTypes.string,
}

ListElement.defaultProps = {
  themeBtn: 'dark',
}

export default ListElement
